<template>
    <div>
        <trax-ui-responsive-table :rows="rows" :cols="cols">
        </trax-ui-responsive-table>

        <div class="text-center mb-3" v-if="!disableProfileButton || !disableExportButton || enableDashboardButton">

            <a :href="profileUrl" class="btn btn-round btn-primary" v-if="!disableProfileButton">
                {{ lang.polaris.dashboard.profile }}
            </a>

            <a :href="exportUrl" class="btn btn-round btn-default" v-if="!disableExportButton && exportAccessPermission">
                {{ lang.polaris.dashboard.export }}
            </a>

            <a :href="dashboardUrl" class="btn btn-round btn-default" v-if="enableDashboardButton">
                {{ lang.polaris.dashboard.dashboard }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
    
        props: {
            disableProfileButton: null,
            disableExportButton: null,
            enableDashboardButton: null,
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                learner: data.learner,
                registration: data.registration,
                cols: [
                    {width: 'sm-6', class: 'text-sm-right font-weight-bold'},
                    {width: 'sm-6' }
                ],
                rows: []
            }
        },

        created: function() {
            this.initRows();
        },

        computed: {

            exportAccessPermission: function() {
                return this.user.admin
                    || this.user.permissions['export.access-registration']
            },

            profileUrl: function() {
                var url = this.app_url+'polaris/ui/atpl-dashboard/learner/'+this.learner.id;
                if (this.registration) url += '?registration_id='+this.registration.id;
                return url;
            },

            exportUrl: function() {
                var url = this.app_url+'polaris/ui/atpl-dashboard/registration/'+this.registration.id;
                url += '/learner/'+this.learner.id+'/export';
                return url;
            },

            dashboardUrl: function() {
                var url = this.app_url+'polaris/ui/atpl-dashboard/registration/'+this.registration.id;
                url += '/learner/'+this.learner.id;
                return url;
            },
        },
        
        methods: {
        
            initRows: function() {

                // Medical Certificate Expiry Date
                var cellClass = '';
                var rowTitle = this.lang.polaris.common.medical_exam_expiry_date;
                if (this.learner.meta.medical_exam_expiry_date) {
                    var diff = moment().diff(this.learner.meta.medical_exam_expiry_date, 'days');
                    if (diff > -14) {
                        cellClass = 'text-danger';
                        rowTitle = '<i class="material-icons" style="position:relative;vertical-align:top;">report_problem</i> ' + rowTitle;
                    } else if (diff > -60) {
                        cellClass = 'text-warning';
                        rowTitle = '<i class="material-icons" style="position:relative;vertical-align:top">report_problem</i> ' + rowTitle;
                    } else {
                        cellClass = 'text-success';
                        rowTitle = '<i class="material-icons" style="position:relative;vertical-align:top">check</i> ' + rowTitle;
                    }
                }
                var title = {
                    content: rowTitle,
                    class: cellClass
                };
                var dateLabel = this.learner.meta.medical_exam_expiry_date ? moment(this.learner.meta.medical_exam_expiry_date).format('DD MMM YYYY') : this.lang.polaris.dashboard.unknown;
                var value = {
                    content: dateLabel,
                    class: cellClass
                };
                this.rows.push([title, value]);

                // Email
                this.rows.push([
                    this.lang.polaris.account.email,
                    this.learner.email
                ]);

                // Employer
                var employer = this.lang.polaris.dashboard.none;
                if (this.learner.entity) employer = this.learner.entity.name;
                if (this.learner.subentity) employer += ' / '+this.learner.subentity.name;
                this.rows.push([
                    this.lang.polaris.dashboard.employer,
                    employer
                ]);

                // Phone number
                this.rows.push([
                    this.lang.polaris.common.phone,
                    this.learner.meta.phone ? this.learner.meta.phone : this.lang.polaris.dashboard.unknown
                ]);

                // Birth date
                this.rows.push([
                    this.lang.polaris.common.birth_date,
                    this.learner.meta.birth_date ? moment(this.learner.meta.birth_date).format('DD MMM YYYY') : this.lang.polaris.dashboard.unknown
                ]);

            }

        }

    }
</script>
